import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { Select, DatePicker, Input } from "antd";
import { Modal, Table, Popconfirm } from "antd";
import React, { useState, useEffect, useContext } from "react";
import CreateAllowance from "./createAllowance";
import {
  getAllEmployeeAllowances,
  deleteEmployeeAllowance,
  getAllAllowances,
  fetchSearchAllowance,
} from "../../service/allowanceService";
import BulkUploadModal from "../../feature-module/hrm/allowanceBulkUpload";
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import moment from "moment"; // Import moment for date handling

const Allowances = () => {
  const { user } = useContext(UserContext);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedAllowance, setSelectedAllowance] = useState(null);
  const [allowances, setAllowances] = useState([]);
  const [epf_number, setEpf] = useState("");
  const [allowanceType, setAllowanceType] = useState("");
  const [name, setName] = useState("");
  const [effectiveDate, setEffectiveDate] = useState(null); // State for effectiveDate
  const [allAllowanceTypes, setAlllowanceTypes] = useState([]);
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const pageSizeOptions = [5, 10, 20, 50, 100];

  useEffect(() => {
    const fetchAllowances = async () => {
      setLoading(true);
      const data = await getAllEmployeeAllowances();
      setLoading(false);
      if (data) {
        setAllowances(data);
        setPagination((prev) => ({ ...prev, total: data.length }));
      } else {
        setAllowances([]);
      }
    };
    fetchAllowances();
  }, []);

  const fetchData = async () => {
    try {
      const data = await getAllAllowances();
      setAlllowanceTypes(data);
    } catch (error) {
      console.error("Error fetching allowances:", error);
    }
  };

  useEffect(() => {
    const fetchAllowanceType = async () => {
      try {
        fetchData()
      } catch (error) {
        console.error("Error fetching types", error)
      }
    }
    fetchAllowanceType()
  }, [])

  const fetchAllowances = async () => {
    setLoading(true);
    const data = await getAllEmployeeAllowances();
    setLoading(false);
    if (data) {
      setAllowances(data);
      setPagination((prev) => ({ ...prev, total: data.length }));
    } else {
      setAllowances([]);
    }
  };

  const handleChangeType = (value) => {
    setAllowanceType(value);
  };

  const getSeachAllowances = async () => {
    const records = await fetchSearchAllowance({
      setLoading,
      epf_number,
      name,
      allowanceType,
      effectiveDate: effectiveDate ? effectiveDate.format("YYYY-MM-DD") : "", // Format date for API
    });
    if (records) {
      setAllowances(records);
      setPagination((prev) => ({ ...prev, total: records.length, current: 1 }));
    } else {
      setAllowances([]);
      setPagination((prev) => ({ ...prev, total: 0, current: 1 }));
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "employee",
      key: "name",
      render: (employee) => employee?.full_name || (employee?.first_name ? `${employee.first_name} ${employee?.last_name || ''}`.trim() : "N/A"),
    },
    {
      title: "EPF No",
      dataIndex: "employee",
      key: "epf",
      render: (employee) => employee?.epf_number || "N/A",
    },
    {
      title: "Allowance Type",
      dataIndex: "allowanceType",
      key: "allowanceType",
      render: (allowanceType) => allowanceType?.name || "N/A",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      render: (effectiveDate) => effectiveDate ? moment(effectiveDate).format("YYYY-MM-DD") : "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <td className="action-table-data">
          {/* Edit Button */}
          <Link
            className={`me-2 p-2 ${
              user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "edit")
                ? ""
                : "disabled"
            }`}
            to="#"
            onClick={() => {
              if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "edit")) {
                setSelectedAllowance(record);
                setOpenCreateModal(true);
              }
            }}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "edit"))
                ? "You don't have permission to edit allowances"
                : "Edit allowance"
            }
          >
            <i data-feather="edit" className="feather-edit"></i>
          </Link>
          
          {/* Delete Button */}
          <Popconfirm
            title="Delete the Allowance"
            description="Are you sure to disable this Allowance?"
            onConfirm={async () => {
              if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "delete")) {
                try {
                  await deleteEmployeeAllowance(record._id);
                  await fetchAllowances();
                } catch (error) {
                  console.error("Error while deleting allowance or fetching data:", error);
                }
              }
            }}
            onCancel={() => console.log("Cancelled")}
            okText="Yes"
            cancelText="No"
            disabled={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "delete"))
            }
          >
            <Link
              className={`confirm-text p-2 ${
                user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "delete")
                  ? ""
                  : "disabled"
              }`}
              title={
                !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "delete"))
                  ? "You don't have permission to delete allowances"
                  : "Delete allowance"
              }
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </Popconfirm>
        </td>
      ),
    },
  ];

  return (
    <div className="page-wrapper-lt">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Allowances</h4>
                <h6>Manage your allowances</h6>
              </div>
            </div>
            
            {/* Bulk Upload Button */}
            <div className="page-btn">
              <a
                className={`btn btn-added-grid ${
                  user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "upload")
                    ? ""
                    : "disabled"
                }`}
                onClick={() => {
                  if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "upload")) {
                    setIsBulkUploadOpen(true);
                  }
                }}
                title={
                  !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "upload"))
                    ? "You don't have permission to bulk upload"
                    : "Bulk upload allowances"
                }
              >
                <PlusCircle className="me-2" />
                Bulk
              </a>
            </div>
            
            {/* Create Allowance Button */}
            <div className="page-btn">
              <a
                className={`btn btn-added ${
                  user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "create")
                    ? ""
                    : "disabled"
                }`}
                onClick={() => {
                  if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "create")) {
                    setOpenCreateModal(true);
                  }
                }}
                title={
                  !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance", "create"))
                    ? "You don't have permission to create allowances"
                    : "Create new allowance"
                }
              >
                <PlusCircle className="me-2" />
                Allowance
              </a>
            </div>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div
              className="container mt-3"
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-3 text-start">
                  <label className="form-label">Employee Name</label>
                  <Input
                    value={name}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                      setName(val);
                    }}
                    allowClear
                    style={{ width: "80%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">EPF No</label>
                  <Input
                    value={epf_number}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setEpf(val);
                    }}
                    allowClear
                    style={{ width: "80%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Allowance Type</label>
                  <Select
                    className="select"
                    options={(allAllowanceTypes || []).map((allowance) => ({
                      value: allowance.name,
                      label: allowance.name,
                    }))}
                    placeholder="Select allowance type"
                    value={allowanceType}
                    onChange={handleChangeType}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "80%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Effective Date</label>
                  <DatePicker
                    className="form-control"
                    placeholder="Select effective date"
                    value={effectiveDate}
                    onChange={(date) => setEffectiveDate(date)}
                    style={{ width: "80%", height: "40px" }}
                    format="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>

            <div
              className="container mt-0"
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              <div className="row d-flex align-items-center justify-content-start">
                <div className="col-12 col-md-2 mb-3 text-start" style={{ display: "flex", gap: "10px" }}>
                  <button
                    disabled={loading}
                    className="btn btn-submit"
                    onClick={getSeachAllowances}
                    style={{ height: "38px" }}
                  >
                    {loading ? "Searching..." : "Search"}
                  </button>
                  <button
                    className="btn btn-reset"
                    onClick={() => {
                      setName("");
                      setEpf("");
                      setAllowanceType("");
                      setEffectiveDate(null);
                      fetchAllowances();
                    }}
                    style={{ height: "38px" }}
                  >
                    Reset
                  </button>
                  {loading && (
                    <div className="spinner">
                      <div className="loading-circle"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top"></div>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={allowances}
                rowKey="value"
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  total: pagination.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={openCreateModal}
        onCancel={() => setOpenCreateModal(false)}
        footer={null}
        maskClosable={true}
        closable={true}
      >
        <CreateAllowance
          selectedAllowance={selectedAllowance?._id}
          handleCancel={() => {
            setSelectedAllowance(null);
            setOpenCreateModal(false);
          }}
          handleReload={fetchAllowances}
        />
      </Modal>
      <BulkUploadModal
        handleCancel={() => setIsBulkUploadOpen(false)}
        isVisible={isBulkUploadOpen}
        onUploadData={fetchAllowances}
      />

      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default Allowances;